import { createStoreModule } from '@next-qr/lib-ui/store';
import { getClient } from '../../miniApps';

export interface StoreSettingsState {
  apiBase: string;
  savedApiBase: string;
  apiBaseSaved: boolean;
  apiBaseChecking: boolean;
  apiBaseError: string | null;
}

export interface StoreSettingsActions {
  setApiBase(s: string): void;
  setApiBaseError(e: string | null): void;
  loadInitial(): Promise<void>;
  saveApiBase(): Promise<void>;
}

export type StoreSettingsStore = StoreSettingsState & StoreSettingsActions;

export const storeSettingsModule = createStoreModule({
  storeSettings: (set: any, get: any): StoreSettingsStore => ({
    // ── State ─────────────────────────────────────────────────────────────────
    apiBase: '',
    savedApiBase: '',
    apiBaseSaved: false,
    apiBaseChecking: false,
    apiBaseError: null,

    // ── Setters ───────────────────────────────────────────────────────────────
    setApiBase: s => set({ apiBase: s }),
    setApiBaseError: e => set({ apiBaseError: e }),

    // ── Async actions ─────────────────────────────────────────────────────────
    async loadInitial() {
      const base = await getClient().getApiBase();
      set({ apiBase: base, savedApiBase: base });
    },

    async saveApiBase() {
      const { apiBase } = get() as StoreSettingsStore;
      set({ apiBaseError: null, apiBaseChecking: true });
      try {
        const client = getClient();
        const prevBase = await client.getApiBase();
        await client.setApiBase(apiBase || null);
        try {
          await client.check();
        } catch {
          await client.setApiBase(prevBase);
          set({ apiBaseError: 'checkFailed' }); // i18n key suffix
          return;
        }
        set({ savedApiBase: await client.getApiBase(), apiBaseSaved: true });
        setTimeout(() => set({ apiBaseSaved: false }), 2000);
      } finally {
        set({ apiBaseChecking: false });
      }
    },
  }),
});

export const useStoreSettings = storeSettingsModule.hooks.useStoreSettings;
